import { useEffect, useState } from "react";
import { MapPin, Phone, Mail, MessageCircle, Navigation } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

const inputCls = "w-full h-12 px-4 rounded-xl border border-stone-300 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30";

export default function Contact() {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  useEffect(() => { api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch { toast.error("Mesaj gönderilemedi"); }
  };

  return (
    <div data-testid="contact-page" className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="font-serif text-3xl sm:text-4xl text-forest">İletişim</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
        <div className="space-y-4">
          {[[MapPin, "Adres", settings?.address], [Phone, "Telefon", settings?.phone], [Mail, "E-posta", settings?.email]].map(([Icon, label, value]) => (
            <div key={label} className="flex items-center gap-4 bg-white rounded-2xl border border-stone-200/80 p-5">
              <Icon className="w-6 h-6 text-forest" />
              <div><p className="text-xs uppercase tracking-wider text-stone-400">{label}</p><p className="font-medium text-stone-900 mt-0.5">{value || "—"}</p></div>
            </div>
          ))}
          {settings?.whatsapp && (
            <a data-testid="contact-whatsapp" href={`https://wa.me/${settings.whatsapp}?text=${encodeURIComponent(`Merhaba, ${settings?.site_name || "Ata Angora Doğal Gıdalar"} iletişim sayfanızdan yazıyorum. Ürünleriniz ve sipariş hakkında bilgi almak istiyorum.`)}`} target="_blank" rel="noreferrer" className="flex items-center gap-4 bg-[#25D366] text-white rounded-2xl p-5 hover:bg-[#20ba5a] transition-colors">
              <MessageCircle className="w-6 h-6" />
              <div><p className="text-xs uppercase tracking-wider text-white/70">WhatsApp</p><p className="font-medium mt-0.5">Bize yazın, hızlıca dönüş yapalım</p></div>
            </a>
          )}
          <p className="text-sm text-stone-500">Çalışma saatleri: Hafta içi 09:00 - 18:00</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-stone-200/80 p-6 space-y-4">
          <input data-testid="contact-name" required className={inputCls} placeholder="Ad Soyad *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <input data-testid="contact-email" type="email" required className={inputCls} placeholder="E-posta *" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input data-testid="contact-phone" className={inputCls} placeholder="Telefon" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          <input data-testid="contact-subject" required className={inputCls} placeholder="Konu *" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
          <textarea data-testid="contact-message" required rows={4} className="w-full px-4 py-3 rounded-xl border border-stone-300 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30" placeholder="Mesajınız *" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
          <button data-testid="contact-submit" className="w-full bg-forest hover:bg-forest-dark text-white font-semibold py-3.5 rounded-xl transition-colors">Gönder</button>
        </form>
      </div>
      {(() => {
        const q = encodeURIComponent(settings?.address || `${settings?.site_name || "Ata Angora Doğal Gıdalar"} Ankara`);
        return (
          <div data-testid="contact-map" className="mt-8 bg-white rounded-2xl border border-stone-200/80 overflow-hidden">
            <div className="flex items-center justify-between px-5 py-3 border-b border-stone-100">
              <p className="text-sm font-semibold text-stone-800 flex items-center gap-2"><MapPin className="w-4 h-4 text-forest" /> Konumumuz</p>
              <div className="flex items-center gap-4">
                <a data-testid="contact-map-open" href={`https://www.google.com/maps/search/?api=1&query=${q}`} target="_blank" rel="noreferrer" className="text-xs font-semibold text-stone-500 hover:text-forest hover:underline">Haritada Aç</a>
                <a data-testid="contact-directions-btn" href={`https://www.google.com/maps/dir/?api=1&destination=${q}`} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 text-xs font-bold text-white bg-forest hover:bg-forest-dark px-3.5 py-2 rounded-lg transition-colors"><Navigation className="w-3.5 h-3.5" /> Yol Tarifi Al</a>
              </div>
            </div>
            <iframe title="Konum" src={`https://www.google.com/maps?q=${q}&output=embed&hl=tr`} className="w-full h-72 sm:h-96 border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
          </div>
        );
      })()}
    </div>
  );
}
